import {
  CLOSE_ICVC_MODAL,
  CREATE_CASE_END,
  GET_ICVC_POLICIES_ERROR,
  GET_ICVC_POLICIES_START,
  GET_ICVC_POLICIES_SUCCESS,
} from 'redux/actions/types';
import { ICVCActionType } from 'redux/actions/icvcActions';
import { ICVCState } from 'ts/types/icvc.types';

export const initState: ICVCState = {
  error: {},
  reviewed: false,
  showModal: false,
};

function icvcReducer(state = initState, action: ICVCActionType) {
  switch (action.type) {
    case CLOSE_ICVC_MODAL:
      return {
        ...state,
        reviewed: true,
        showModal: false,
      };
    case GET_ICVC_POLICIES_SUCCESS:
      return {
        ...action.payload,
        error: {},
        reviewed: true,
        showModal: true,
      };
    case GET_ICVC_POLICIES_ERROR:
      return {
        ...state,
        error: action.payload,
        showModal:
          action.payload?.status >= 400 && action.payload?.status < 500,
      };
    case GET_ICVC_POLICIES_START:
      return { ...initState, reviewed: state.reviewed };
    case CREATE_CASE_END:
      return initState;
    default:
      return state;
  }
}

export default icvcReducer;
